export default function auth ({ next, store }){
    if(!store.state.auth.portfolio && !window.userAuth){
        return next({
            name: 'login',
        });
    }

    return next();
}